const actions = {
  // Listar Papéis

  criarFuncao: async (context, { vendor_id, funcao }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`/functions`, {
      vendor_id,
      function: funcao,
    });

    return response;
  },
  listarFuncao: async (context, { unidade, per_page, page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`/functions`, {
      params: {
        page,
        per_page,
        vendor_id: unidade,
        search,
      },
    });

    return response;
  },
  removerFuncao: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`/functions/${id}`);

    return response;
  },
  removerRegras: async (context, { vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`/regras/funcao`, {
      params: {
        vendor_id,
      },
    });

    return response;
  },

  indexar: async (context, { function_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`/regra/reindexar-usuarios`, {
      ghes: [function_id],
    });

    return response;
  },

  editarFuncao: async (context, { id, nome }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`/functions/${id}`, {
      id,
      nome,
    });

    return response;
  },

  getPessoas: async (context, { id, per_page, page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`/functions/${id}/users`, {
      params: {
        id,
        per_page,
        page,
        usuario: search,
      },
    });

    return response;
  },
  listarGrupo: async (context, { per_page, page, search, vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`/product-groups`, {
      params: {
        per_page,
        page,
        search,
        vendor_id,
      },
    });

    return response;
  },

  funcaoGrupo: async (context, { per_page, page, search, id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`/functions/${id}/product-groups`, {
      per_page,
      page,
      search,
    });

    return response;
  },

  funcaoGrupoDeletar: async (context, { funcao_id, id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(
      `/product-groups/${funcao_id}/functions/${id}`
    );

    return response;
  },

  editarFuncaoRegras: async (
    context,
    {
      id,
      maximum_days,
      minimum_days,
      control_types,
      amount,
      function_id,
      unidade,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/product-groups/${id}/functions`, {
      maximum_days,
      minimum_days,
      control_types,
      amount,
      group_id: id,
      function_id,
      vendor_id: unidade,
    });

    return response;
  },

  adicionarRegraFuncao: async (
    context,
    {
      group_id,
      maximum_days,
      minimum_days,
      control_types,
      amount,
      function_id,
      critico,
      vendor_id,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`/product-groups/${group_id}/functions`, {
      maximum_days,
      minimum_days,
      control_types,
      amount,
      group_id,
      function_id,
      critico,
      vendor_id,
    });

    return response;
  },
};

export const processos = {
  namespaced: true,
  actions,
};
